// Diccionario ESPAÑOL, montado por fragmentos, exactamente como fr/.
// Cada fragmento lleva las mismas claves que su homólogo de fr/ ; el objeto
// final es plano : 'espacio.clave' -> texto.
//
// NB : es/common.js lleva además las claves packs.<id>.<campo>, que no existen
// del lado francés (en francés los textos de producto vienen de la base de
// datos ; tp()/tpList() solo leen estas claves para los demás idiomas).
import common from './common';
import home from './home';
import experience from './experience';
import shop from './shop';
import fiche from './fiche';
import tunnel from './tunnel';
import regles from './regles';
import divers from './divers';

export default {
  ...common,
  ...home,
  ...experience,
  ...shop,
  ...fiche,
  ...tunnel,
  ...regles,
  ...divers,
};
